// extracted by mini-css-extract-plugin
export default {"wrapper":"Page404_wrapper__hEHR6","title":"Page404_title__SFulE","text":"Page404_text__th4AL"};